// 2023/12/20 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  new_education_user_name: string;
  education_user_name: string;
  user_name: string;
}

const initialState: InitialState = {
  new_education_user_name: '',
  education_user_name: '',
  user_name: '',
};

export const kakuninSlice = createSlice({
  name: 'kakuninSlice',
  initialState,
  reducers: {
    saveInfo: (state, { payload }) => {
      state.new_education_user_name = payload.new_education_user_name;
      state.education_user_name = payload.education_user_name;
      state.user_name = payload.user_name;
    },
  },
  extraReducers() {},
});

export const { saveInfo } = kakuninSlice.actions;

export default kakuninSlice.reducer;
// 2023/12/20 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
